import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbDateCustomParserFormatter } from './shader/adapter/dateformat';
import { DataTablesModule } from 'angular-datatables';
import { DatePipe } from '@angular/common'
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    AppComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    DataTablesModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      // positionClass:'toast-bottom-right'
      positionClass: 'toast-top-center'
    }),
  ],
  providers: [
    // {
    //   provide: 'apiUrl',useValue: 'http://localhost:52520/'
    // },

    // Lokalde Çalışacak Test Kurulum
    // {
    //   provide: 'apiUrl',useValue: 'http://localhost:8065/'
    // },

    // Eropa Development - MsSQL
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.1.199:9016/'
    // },

    // //HOMMAK
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.100.69:8081/'
    // },

    // //sertplas yeni
    // {
    //   provide: 'apiUrl',useValue: 'http://10.0.0.36:9054/'
    // },

    // Solufert
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.1.94:8484/'
    // },

    // SolufertParalelDB
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.1.94:8586/'
    // },

    // Mass
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.1.15:8086/'
    // },

    //Mateks
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.1.254:8580/'
    // },
    // Interplast
    // {
    //   provide: 'apiUrl',useValue: 'http://172.16.3.246:8585/'
    // },

    // Özbir Vagon
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.10.20:8081/'
    // },

    // ElmaslarTest
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.0.6:9010/'
    // },

    // ElmaslarCanlı
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.0.6:9019/'
    // },

    // Eurobig
    // {
    //   provide: 'apiUrl',useValue: 'http://10.40.160.2:8082/'
    // },

    // Bağışlar Un
    // {
    //   provide: 'apiUrl',useValue: 'http://192.168.2.152:8094/'
    // },

    // Merba Plastik
    // {
    //   provide: 'apiUrl',useValue: 'http://10.40.64.3:8091/'
    // },

    //Ateşsönmez
    // {
    //   provide: 'apiUrl',useValue: 'http://10.30.2.12:8091/'
    // },

    //Ateşsönmez Yeni
    // {
    //   provide: 'apiUrl',useValue: 'http://10.30.2.12:8091/'
    // },

    //Türbosan
    // {
    //   provide: 'apiUrl',useValue: 'http://172.16.11.11:8021/'
    // },

    //Eropa SQL Test Sunucu 

    {
      provide: 'apiUrl',useValue: 'http://192.168.1.242:8020/'
    },

    //Emf

    // {
    //   provide: 'apiUrl',useValue: 'http://10.10.0.20:8010/'
    // },

    //EMF Canlı
    // {
    //   provide: 'apiUrl',useValue: 'http://10.10.0.20:8040/'
    // },


    DatePipe,
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }
